/**
 * Formats a YYYY-MM-DD post date for display.
 *
 * Parsed as UTC deliberately: `new Date('2026-08-04')` is midnight UTC, which
 * renders as the previous day for anyone west of Greenwich if formatted in
 * local time. Post dates are calendar dates, not instants.
 */
export function formatDate(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;

  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  });
}
